export default () => {
  return new Promise((resolve) => {
    const checkAndResolve = () => {
      if (window.jQuery) {
        resolve(window.jQuery);
      } else {
        setTimeout(checkAndResolve, 500);
      }
    };

    checkAndResolve();
  });
};
